import 'inventory-listing/components/ListingFilters/Components/ListingFiltersDriveTrain/ListingFiltersDriveTrain.scss';

import React from 'react';
import PropTypes from 'prop-types';
import { findIndex, map, includes } from 'lodash';

import { LocaleService, UrlService } from '@sm360/widget-commons-core-services';
import { AnalyticsService, TRACKING_TAGS as TAGS } from '@sm360/widget-commons-general';

import MetaDataModel from 'inventory-listing/models/MetaDataModel.js';

import DriveTrain from 'inventory-listing/components/ListingFilters/Components/ListingFiltersDriveTrain/DriveTrain.jsx';

class ListingFiltersDriveTrain extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            driveTrains: this.mapDriveTrains(props.driveTrains),
        };
        this.handleChange = this.handleChange.bind(this);
    }

    componentWillReceiveProps(newProps) {
        this.setState({
            driveTrains: this.mapDriveTrains(newProps.driveTrains),
        });
    }

    mapDriveTrains(driveTrains) {
        const queryParamDriveTrains = UrlService.getUrlParameter('drivetrains');
        const selectedDriveTrains = queryParamDriveTrains
            ? queryParamDriveTrains.split(',').map((id) => parseInt(id, 10))
            : [];

        return map(driveTrains, (driveTrain) => {
            return driveTrain.set('isSelected', includes(selectedDriveTrains, driveTrain.code));
        });
    }

    handleChange(code) {
        const driveTrains = this.state.driveTrains;
        const index = findIndex(driveTrains, { code });

        driveTrains[index] = driveTrains[index].set('isSelected', !driveTrains[index].isSelected);

        if (driveTrains[index].isSelected) AnalyticsService.ga4Trigger(TAGS.DRIVE_TRAIN(driveTrains[index].label));

        this.props.updateVehicleCriteria(driveTrains, 'drivetrains', driveTrains[index].isSelected);

        this.setState({
            driveTrains,
        });
    }

    render() {
        const driveTrains = this.state.driveTrains.map((driveTrain) => (
            <DriveTrain key={driveTrain.code} driveTrain={driveTrain} handleChange={this.handleChange} />
        ));

        return (
            <div className="listing-used-filters-bloc listing-used-filters-drivetrain">
                <div className="listing-used-filters-title sr-text is-bold">
                    {LocaleService.t('FILTERS.DRIVETRAIN')}
                </div>
                <ul className="clearfix">{driveTrains}</ul>
            </div>
        );
    }
}

ListingFiltersDriveTrain.defaultProps = {
    driveTrains: [],
};

ListingFiltersDriveTrain.propTypes = {
    driveTrains: PropTypes.arrayOf(PropTypes.instanceOf(MetaDataModel)),
    updateVehicleCriteria: PropTypes.func.isRequired,
};

ListingFiltersDriveTrain.displayName = 'ListingFiltersDriveTrain';

export default ListingFiltersDriveTrain;
